module.exports = __webpack_public_path__ + "img/corner-right-down.21c006a7.svg";